import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-factory-transaction-listing', {
    mixins: [AppListing],
    data: function() {
        return {
            tabSelected : 'testt',
        }
    },
    methods: {
        hasActive (tab){
            return this.tabSelected==tab?'active':''
        }
    },
    
});